module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CX - Christmas Island.02f7ffb0.svg";